module.exports = __webpack_public_path__ + "static/img/encyclopediaIndexBg.9d38a91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/testTubeEncyclopedia/images/encyclopediaIndexBg.jpg
// module id = mPdF
// module chunks = 7